
import { Intervention } from "@/types";
import { deleteData, getData, postData, putData } from "./axios-service";

function interventionMapper(inputIntervention: any): Intervention {
    return {
        id: inputIntervention.id,
        comment: inputIntervention.comment,
        productId: inputIntervention.productId,
        taskId: inputIntervention.taskId,
        items: inputIntervention.items || [],
    };
}

function interventionMapperArray(inputInterventionArray: any[]): Intervention[] {
    return inputInterventionArray.map(interventionMapper);
}

export async function fetchInterventionsByTaskId(taskId: string): Promise<Intervention[]> {
    const response = await getData<Intervention[]>("/tasks/" + taskId + "/interventions");
    return interventionMapperArray(response ?? []);
}

export async function postIntervention(template: Intervention): Promise<Intervention> {
    const response = await postData("/interventions", template);
    return interventionMapper(response);
}

export async function fetchInterventions(): Promise<Intervention[]> {
    const templates  = await getData<Intervention[]>("/interventions");
    return interventionMapperArray(templates ?? []);
}

export function fetchInterventionById(id: string): Promise<Intervention> {
    return getData("/interventions/" + id).then(
        onSucceed => {
            return interventionMapper(onSucceed);
        }
    );
}

export function putIntervention(intervention: Intervention): Promise<any> {
    return putData("/interventions/" + intervention.id, intervention);
}

export function deleteIntervention(id: string): Promise<any> {
    return deleteData("/interventions/" + id);
}
